import { useAuthentication } from "@/Slices/authenticationSlice";
import type { SavedCommodity } from "@freightsimple/generated-dashboard-openapi-client/models/SavedCommodity";
import { useOnce } from "@/Hooks/useOnce";
import { useState } from "react";
import { useSavedCommoditiesService } from "../Services/SavedCommoditiesService";

export function useSavedCommodities() {
  const { isAuthenticated } = useAuthentication();
  const savedCommoditiesService = useSavedCommoditiesService();
  const [loadingSavedCommodities, setLoadingSavedCommodities] = useState(true);
  const [savedCommoditiesLoadFailed, setSavedCommoditiesLoadFailed] =
    useState(false);
  const [savedCommodities, setSavedCommodities] = useState<
    Array<SavedCommodity>
  >([]);

  async function loadSavedCommodities() {
    if (!isAuthenticated) {
      setLoadingSavedCommodities(false);
      return;
    }
    setLoadingSavedCommodities(true);
    setSavedCommoditiesLoadFailed(false);
    try {
      setSavedCommodities(
        await savedCommoditiesService.getAllSavedCommodities(),
      );
    } catch (e) {
      console.warn("Error loading saved commodities:", { e });
      setSavedCommoditiesLoadFailed(true);
    } finally {
      setLoadingSavedCommodities(false);
    }
  }

  useOnce(async () => {
    await loadSavedCommodities();
  });

  return {
    savedCommodities,
    loadingSavedCommodities,
    savedCommoditiesLoadFailed,
    reloadSavedCommodities: loadSavedCommodities,
  };
}
